import { Controller } from "@hotwired/stimulus";

// Shows the picture a link points to, enlarged in a modal <dialog>. Escape,
// a click anywhere on the dialog (including the backdrop) closes it. The
// picture is only fetched when the dialog is opened.
export default class extends Controller {
  static targets = ["dialog", "image", "caption"];

  open(event) {
    event.preventDefault();
    const link = event.currentTarget;
    this.imageTarget.src = link.href;
    this.captionTarget.textContent = link.title;
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  closed() {
    this.imageTarget.removeAttribute("src");
  }
}
